import $ from 'jquery'

const $price = $('.summary .price_wrap');
const $stock = $('.summary .stock_wrap');
const $desc = $('.woocommerce-product-details__short-description');
const $sku = $('.product-sku .sku');
const $weight = $('.product-weight .weight')
const $dimensions = $('.product-dimensions .dimensions')

const price_html = $price.html();
const stock_html = $stock.html();
const desc_html = $desc.html();
const sku_html = $sku.html();
const weight_html = $weight.html()
const dimensions_html = $dimensions.html()

if ($dimensions.text() === 'N/A') {
    $dimensions.hide()
    $('.product-dimensions').hide()
}

if ($weight.text() === '') {
    $weight.hide()
    $('.product-weight').hide()
}

$(document).on('found_variation', 'form.cart', function (event, variation) {
    $price.html(variation.price_html ? variation.price_html : price_html);
    $stock.html(variation.availability_html ? variation.availability_html : stock_html);
    $sku.html(variation.sku ? variation.sku : sku_html);
    if (variation.weight !== '') {
        $weight.show()
        $('.product-weight').show()
    }
    $weight.html(variation.weight ? variation.weight : weight_html);
    if (variation.dimensions_html !== 'N/A') {
        $dimensions.show()
        $('.product-dimensions').show()
    }
    $dimensions.html(variation.dimensions_html ? variation.dimensions_html : dimensions_html);
});

$(document).on('hide_variation', 'form.cart', function () {
    $price.html(price_html);
    $stock.html(stock_html);
    $desc.html(desc_html);
    $sku.html(sku_html);
    $dimensions.html(dimensions_html);
    $weight.html(weight_html);

    if ($dimensions.text() === 'N/A') {
        $dimensions.hide()
        $('.product-dimensions').hide()
    }

    if ($weight.text() === ' lbs') {
        $weight.hide()
        $('.product-weight').hide()
    }
});

$( '.variations_form' ).on( 'click', '.swatch', function ( e ) {
    const el = $( this );
    const select = el.closest( '.value' ).find( 'select' );
    const value = el.data( 'value' );

    el.addClass( 'selected' ).siblings( '.selected' ).removeClass( 'selected' );
    select.val( value );
    select.change();

} );
